import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DragHandlerIcon = React.memo<IconProps>(
  ({ className = '', size = 24, color = '#979798', onClick, strokeWidth }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 4 26"
    >
      <g clipPath="url(#clip0_1885_4346)">
        <rect width="2" height="2" fill={color} />
        <rect y="6" width="2" height="2" fill={color} />
        <rect y="12" width="2" height="2" fill={color} />
        <rect y="18" width="2" height="2" fill={color} />
        <rect y="24" width="2" height="2" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1885_4346">
          <rect width="4" height="26" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  ),
);

DragHandlerIcon.displayName = 'DragHandlerIcon';
